import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleRight } from '@primeicons/core/angle-right';

@Component({
    selector: 'svg[data-p-icon="angle-right"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleRight extends CoreIcon {
    constructor() {
        super();
        this._icon = angleRight;
    }
}
